import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { lottieAnimations, NUGGET_VARIANTS } from '@backrs_ui/common-ui/dist';
import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { resetCollege, selectCollege } from '@backrs_ui/grow-ui/src/redux/college/college';
import { searchForCollegeById } from '@backrs_ui/grow-ui/src/redux/college/college.thunks';
import { useAppSelector, useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  deleteContentNuggetBookmark,
  postContentNuggetBookmark,
} from '@backrs_ui/grow-ui/src/redux/user/thunks/nuggetBookmark';
import { selectBookmarkedNuggetId } from '@backrs_ui/grow-ui/src/redux/user/user';

import { Box, Theme, SxProps } from '@mui/material';
import Lottie from 'lottie-react';

import { CollegePage } from './CollegePage';
import { SEARCH_PAGE_CATEGORIES } from '../Search/search.types';

export const CollegePageContainer = () => {
  const { universityId } = useParams();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const foundCollege = useAppSelector(selectCollege);

  const collegeBookmarkId = useAppSelector(
    selectBookmarkedNuggetId({
      nuggetId: foundCollege?.id,
      variant: NUGGET_VARIANTS.INSTITUTION,
    }),
  );

  useEffect(() => {
    if (!universityId) {
      navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.COLLEGES}`);

      return;
    }

    dispatch(searchForCollegeById({ id: universityId }));

    return () => {
      dispatch(resetCollege()); // when we navigate away from the page, reset the college state to ensure we don't have any stale data when navigating back
    };
  }, [navigate, universityId, dispatch]);

  if (!foundCollege) {
    return (
      <Box sx={loadingContainerSx}>
        <Lottie animationData={lottieAnimations.dotsDotting} />
      </Box>
    );
  }

  const handleBookmark = () => {
    if (collegeBookmarkId) {
      dispatch(deleteContentNuggetBookmark(collegeBookmarkId));

      return;
    }

    dispatch(postContentNuggetBookmark({ type: 'college', itemId: foundCollege.id }));
  };

  return (
    <CollegePage
      college={foundCollege}
      handleBookmark={handleBookmark}
      hasBookmarked={!!collegeBookmarkId}
    />
  );
};

const loadingContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100dvh',
  width: '100dvw',
};
